import React, {useState} from 'react';
import {Box} from '@mui/material';
import ManageHeader from '../components/manage-header/ManageHeader';
import {t} from 'i18next';
import BatchRedactionTree from './batch-redaction-tree/BatchRedactionTree';
import {BatchRedactionHistoryGrid} from './batch-redaction-history-grid/BatchRedactionHistoryGrid';

const BatchRedaction: React.FC = () => {
  const [refreshBatchRedactionHistory, setRefreshBatchRedactionHistory] =
    useState<boolean>(false);

  return (
    <Box className="batch-redactions-container">
      <ManageHeader
        isShowGroup={false}
        title={t('batchRedactions.title')}
        infoContentTitle={t('batchRedactions.title')}
        infoContent={t('batchRedactions.headerTooltip')}
      />
      <BatchRedactionTree
        onRedactionCompletion={() => setRefreshBatchRedactionHistory(true)}
      />
      <BatchRedactionHistoryGrid
        refreshBatchRedactionHistory={refreshBatchRedactionHistory}
      />
    </Box>
  );
};

export default BatchRedaction;
